/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {BaseComponent} from "@intuitionrobotics/thunderstorm/frontend";
import {
	padding_rl_med,
	Spacing
} from "@styles/styles";
import {COLORS} from "@res/colors";
import {FONTS} from "@res/fonts";
import {IconArrows} from "@res/icons-tsx/IconArrows";

type Props = {
	title?: string,
	options?: { sortable?: boolean },
	column?: string
	sort?: { func: () => void, up?: boolean},
	color: string
}

export class TableHeader
	extends BaseComponent<Props, {}> {

	constructor(props: Props) {
		super(props);
	}

	private headerStyle = () => {
		return <div className={`ll_h_c ${padding_rl_med}`} style={{height: 34, backgroundColor: this.props.color}}>
			{this.props.title && FONTS.reg_14_secondary_dark(this.props.title, {whiteSpace: "nowrap", color: '#6d7278'})}
			{this.props.options && this.props.options.sortable && <div style={{cursor: "pointer"}} onClick={() => {
				if (!this.props.column)
					return;
				this.props.sort && this.props.sort.func();
			}}>
				<div><IconArrows
					style={{marginLeft: Spacing.l}}
					colorOn={COLORS.neutral_text_dark}
					up={this.props.sort?.up === true}
					down={this.props.sort?.up === false}
				/></div>
			</div>}
		</div>;
	};

	render() {
		return this.headerStyle();
	}
}
